module.exports = __webpack_public_path__ + "img/undraw_ideas_s70l.371b021a.svg";